import NewOrganization from 'components/ui/organizations/NewOrganization';

export default NewOrganization;
